import React, {useEffect, useRef, useState} from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import './ReportStyles.css';
import axios from "axios";
import { Button } from "@heroui/react";

const PowerbiMobile = () => {
    const [embedConfig, setEmbedConfig] = useState(null); // Estado para la configuración del embed
    const [loading, setLoading] = useState(true); // Estado para mostrar un indicador de carga
    // PowerBI Report object (to be received via callback)
    const reportRef = useRef(null);
    const [pages, setPages] = useState([]); // Estado para almacenar las páginas

    useEffect(() => {
        axios.post('https://quickview.rskgroupco.com/app/powerbi')
            .then(response => {
                const { report_id, embed_url, access_token } = response.data; // Asume que la respuesta contiene report_id y access_token
                setEmbedConfig({
                    reportId: report_id,
                    embedUrl: embed_url,
                    accessToken: access_token
                });
                setLoading(false);
                console.log("success")
            })
            .catch(error => {
                console.error('Error al obtener los datos del reporte:', error);
                setLoading(false); // Ocultar el indicador de carga aunque falle
            });
    }, []);

    const onReportLoaded = (report) => {
        // Save the report instance for further interactions
        reportRef.current = report;
    };

    // Función para cargar las páginas
    const getPages = async () => {
        if (reportRef.current) {
            try {
                const reportPages = await reportRef.current.getPages();
                setPages(reportPages); // Guarda las páginas en el estado
                console.log("Páginas disponibles:", reportPages);
            } catch (error) {
                console.error("Error al obtener las páginas:", error);
            }
        }
    };

    const goToPage = async (pageName) => {
        if (reportRef.current) {
            try {
                const pages = await reportRef.current.getPages();
                console.log("paginas: ", pages)
                //const targetPage = pages.find((page) => page.displayName === pageName);
                const targetPage = pages.find((page) => page.name === pageName);

                if (targetPage) {
                    await targetPage.setActive();
                    console.log(`Navigated to page: ${pageName}`);
                } else {
                    console.error(`Page with name ${pageName} not found`);
                }
            } catch (error) {
                console.error("Error navigating to page:", error);
            }
        } else {
            console.error("Report is not loaded");
        }
    };


    return (
        <>
            {loading ? (
                <div className="loading-indicator">Loading...</div> // Indicador de carga
            ) : (
                embedConfig && (
                    <div>
                        {/* Contenedor de los botones */}
                        <div className="button-scroll">
                            {pages.map((page) => (
                                <React.Fragment key={page.name}>
                                    <Button
                                        size="sm"
                                        color="primary"
                                        variant="solid"
                                        onClick={() => goToPage(page.name)}
                                    >
                                        {page.displayName}
                                    </Button>
                                </React.Fragment>
                            ))}
                        </div>

                        {/* Reporte incrustado */}
                        <PowerBIEmbed
                            embedConfig={{
                                type: 'report', // Tipo de embed (reporte, dashboard, etc.)
                                id: embedConfig.reportId, // ID del informe en Power BI
                                embedUrl: embedConfig.embedUrl, // URL de incrustación del informe
                                accessToken: embedConfig.accessToken, // Token de acceso de Power BI
                                tokenType: models.TokenType.Embed,
                                settings: {
                                    panes: {
                                        filters: {
                                            visible: false
                                        },
                                        pageNavigation: {
                                            visible: true
                                        }
                                    },
                                    layoutType: models.LayoutType.MobilePortrait,
                                    //layoutType: models.LayoutType.MobileLandscape,
                                    background: models.BackgroundType.Transparent,
                                }
                            }}
                            cssClassName="report-style-class-mobile" // Clases CSS personalizadas
                            pageView="fitToWidth"
                            onError={(error) => {
                                console.error('Error al cargar el informe:', error);
                            }}
                            eventHandlers={
                                new Map([
                                    ["loaded", () => {
                                        console.log("Report loaded");
                                        getPages();
                                    }],
                                    ["rendered", () => console.log("Report rendered")],
                                    ["error", (event) => console.error("Error:", event.detail)],
                                    ["pageChanged", (event) => console.log("Página cambiada:", event.detail.newPage.name)],
                                    ["dataSelected", (event) => console.log("Datos seleccionados:", event.detail.dataPoints)],
                                    ["filtersApplied", () => console.log("Filtros aplicados")],
                                    ["visualRendered", (event) => console.log("Visual renderizado:", event.detail)],
                                    ["buttonClicked", (event) => console.log("Botón clickeado:", event.detail)],
                                    ["commandTriggered", (event) => console.log("Comando activado:", event.detail)],
                                ])
                            }
                            getEmbeddedComponent={(embeddedReport) => onReportLoaded(embeddedReport)}

                        />
                    </div>
                )
            )}
        </>
    );
}

export default PowerbiMobile